// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"MainTitle_titleContainer__3yOvJ"};